import React, {useEffect, useState} from "react";
import styles from './BroadcastNotification.module.scss';
import Button, {
    BUTTON_TYPE_SECONDARY, BUTTON_TYPE_SECONDARY_PURPLE,
} from "../../Components/Button/Button";
import Modal from "../../Components/Modal/Modal";
import TextInput from "../../Components/TextInput/TextInput";
import ImageSubmit from "../../Components/ImageSubmit/ImageSubmit";
import TextAreaInput from "../../Components/TextAreaInput/TextAreaInput";
import toast from "react-hot-toast";
import {errorToast, successToast} from "../../helpers/toastCSS";
import SelectInput from "../../Components/SelectInput/SelectInput";
import Checkbox from "../../Components/Checkbox/Checkbox";
import {PROD_API_URL} from "../../constants/constants";
import {handleImageUpload} from "../../helpers/helperFunctions";

const MESSAGE_TYPE_REWARD = 'reward';
const MESSAGE_TYPE_INFO = 'info';
const MESSAGE_TYPE_WARNING = 'warning';
const MESSAGE_TYPE_IDO = 'ido';
const MESSAGE_TYPE_RAFFLE = 'raffle';

const MESSAGE_TYPES = [
    {
        value: MESSAGE_TYPE_REWARD,
        label: 'Reward',
    },
    {
        value: MESSAGE_TYPE_INFO,
        label: 'Info',
    },
    {
        value: MESSAGE_TYPE_WARNING,
        label: 'Warning',
    },
    {
        value: MESSAGE_TYPE_IDO,
        label: 'IDO',
    },
    {
        value: MESSAGE_TYPE_RAFFLE,
        label: 'Raffle',
    },
]

const BroadcastNotification = (props) => {
    const {
        notification,
        setNotification,
        fetchNotifications,
    } = props;

    const [open, setOpen] = useState(false);
    const [messageTitle, setMessageTitle] = useState('');
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState(MESSAGE_TYPE_INFO);
    const [notificationImage, setNotificationImage] = useState();
    const [imageFileInfo, setImageFileInfo] = useState();
    const [linkURL, setLinkURL] = useState('');
    const [linkButtonText, setLinkButtonText] = useState('');
    const [recipients, setRecipients] = useState();
    const [sendAllUsers, setSendAllUsers] = useState(true);

    useEffect(() => {
        if (notification) {
            setOpen(true);
            setMessageTitle(notification.title);
            setMessage(notification.message);
            setMessageType(notification.type);
            setNotificationImage(notification.image);
            setLinkURL(notification.linkURL);
            setLinkButtonText(notification.linkButtonText);
            setRecipients(notification.recipients);
            setSendAllUsers(notification.broadcastType === 'all');
        }
    }, [notification])

    const sendNotification = async () => {
        try {
            const body = {
                title: messageTitle,
                message,
                type: messageType,
                image: imageFileInfo ? await handleImageUpload(imageFileInfo, 'notifications', messageTitle) : notificationImage,
                actionType: 'message',
                channels: ['inApp'],
                link: {
                    url: linkURL,
                    buttonText: linkButtonText,
                    externalPage: !linkURL.includes('app.starlaunch')
                },
                broadcastType: sendAllUsers ? 'all' : 'specific',
                recipients: sendAllUsers ? [] : recipients.split(','),
            };

            if (notification) {
                body.id = notification.id;
            }

            await fetch(PROD_API_URL + "/notification/broadcast", {
                "method": "POST",
                "headers": {"content-type": "application/json", "accept": "*"},
                "body": JSON.stringify(body)
            });
            toast('Notification Sent!', successToast);
            setOpen(false);
            await fetchNotifications();
            if (notification) {
                setNotification(null);
            }
        } catch (e) {
            console.error(e);
            toast('Error sending notification: ' + e, errorToast);
        }
    }

    return (
        <div className={styles.broadcastNotificationContainer}>
            <Button text="Create New Notification" buttonType={BUTTON_TYPE_SECONDARY_PURPLE} onClick={() => setOpen(true)}/>
            <Modal
                exit
                confirmButtonText={notification ? 'Update Notification' : 'Broadcast Notification'}
                onConfirm={sendNotification}
                show={open}
                setShow={setOpen}>
                <div className={styles.broadcastNotificationModal}>
                    <h4>Broadcast Notification</h4>
                    <TextInput value={messageTitle} setValue={setMessageTitle} label="Message Title"/>
                    <SelectInput
                        value={messageType}
                        setValue={setMessageType}
                        label="Message Type"
                        options={MESSAGE_TYPES}
                    />
                    <TextAreaInput value={message} setValue={setMessage} label="Message" rows={3}/>
                    <ImageSubmit
                        useBase64={false}
                        preview={notificationImage}
                        setFileInfo={setImageFileInfo}
                        text="Notification Image"/>
                    <div className={styles.recipientRow}>
                        <div className={styles.checkboxContainer}>
                            <TextInput value={linkButtonText} setValue={setLinkButtonText} label="Button Label"/>
                        </div>
                        <TextInput value={linkURL} setValue={setLinkURL} label="Link URL"/>
                    </div>
                    <div className={styles.recipientRow}>
                        <div className={styles.checkboxContainer}>
                            <Checkbox
                                id="sendAllUsers"
                                label="Send to all users"
                                onChange={event => setSendAllUsers(event.target.checked)}
                                checked={sendAllUsers}
                            />
                        </div>
                        <TextInput value={recipients} setValue={setRecipients} label="Recipients"
                                   disabled={sendAllUsers}/>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default BroadcastNotification;
